define('views/parts/modal/gallery',[
    // Don't import 'jquery' unnecessarily, use Backbone.$ or this.$ or this.$el
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    // models
    // collections
    // views
    // templates
    'text!templates/parts/modal/gallery.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    // templates
    TGallery
) {

    // Component to add a single image
    var VGallery = Backbone.Epoxy.View.extend({
        template: TGallery,

        computeds: {
            imageUrl: {
                get: function() {
                    return this.options.imageUrl
                }
            }
        },

        initialize: function(options) {
            // additional options passed to the constructor.
            this.options = _.extend({}, options);

            this.bindingSources = {
                imageUrl: new Backbone.Model({ imageUrl: this.options.imageUrl })
            }
        },

        render: function() {
            var data = Mustache.getContext(
                _.extend({
                    imageUrl: this.options.imageUrl
                })
            );
                
            var html = Mustache.render(this.template, data);
            this.$el.empty().append(html);

            this.generateZones()
                .applyBindings();

            return this; 
        },

    });

    return VGallery;
});

